import { AutomationServerListSection } from "@/components/automation-server/AutomationServerListSection";
import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { useTitleBar } from "@/context/TitleBarProvider";
import { Plus, RefreshCw, Server, Cloud, ChevronDown } from "lucide-react";
import { ConnectAutomationServerModal } from "@/components/automation-server/ConnectAutomationServerModal";
import { ProvisionHetznerServerModal } from "@/components/automation-server/ProvisionHetznerServerModal";
import { useAutomationServersQuery } from "@/hooks/useAutomationServersQuery";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const AutomationServersPage = () => {
  const { setTitle, setIcon, setButtons } = useTitleBar();
  const [highlightedServerId, setHighlightedServerId] = useState<string | null>(null);
  const { refetch, isFetching } = useAutomationServersQuery();
  const [showBYOSModal, setShowBYOSModal] = useState(false);
  const [showHetznerModal, setShowHetznerModal] = useState(false);

  useEffect(() => {
    setTitle("Automation Servers");
    setIcon(<Server size={24} />);
    setButtons(
      <>
        <Button
          variant="outline"
          onClick={() => refetch()}
          disabled={isFetching}
        >
          <RefreshCw size={20} className={isFetching ? "animate-spin" : ""} />
          Refresh
        </Button>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button>
              <Plus size={20} />
              New server
              <ChevronDown size={16} />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => setShowHetznerModal(true)}>
              <Cloud size={16} className="mr-2" />
              Cloud (Hetzner)
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setShowBYOSModal(true)}>
              <Server size={16} className="mr-2" />
              Bring Your Own
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </>
    )
  }, [setTitle, setIcon, setButtons, isFetching, refetch]);

  const handleServerCreated = (serverId: string) => {
    setHighlightedServerId(serverId);
    refetch();
    setTimeout(() => {
      setHighlightedServerId(null);
    }, 5000);
  };

  return (
    <div>
      <AutomationServerListSection
        highlightedServerId={highlightedServerId}
      />

      {/* BYOS Modal */}
      <ConnectAutomationServerModal
        open={showBYOSModal}
        onOpenChange={setShowBYOSModal}
        onServerCreated={handleServerCreated}
      />

      {/* Hetzner Cloud Modal */}
      <ProvisionHetznerServerModal
        open={showHetznerModal}
        onOpenChange={setShowHetznerModal}
        onServerCreated={handleServerCreated}
      />
    </div>
  );
};

export default AutomationServersPage;
